export function supportsTouch() {
  return window.matchMedia("screen and (hover: none)").matches;
}

export function prefersReducedMotion() {
  return window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;
}
